import React, { useState } from "react";
import { Choice as Choice } from "../survey-types";
import { Plus } from "@/components/Plus";

interface MultipleChoiceEditorProps {
  choices: Choice[];
  onChange: (q: Choice[]) => void;
}

const MultipleChoiceEditor: React.FC<MultipleChoiceEditorProps> = ({
  choices: choices,
  onChange,
}) => {
  const handleChoiceChange = (
    choiceIndex: number,
    key: keyof Choice,
    value: string
  ) => {
    const opts = [...choices];
    opts[choiceIndex][key] = value;
    onChange(opts);
  };

  const handleAddChoice = () => {
    const opts = choices ? [...choices] : [];
    opts.push({
      text: "",
    });
    onChange(opts);
  };

  const handleRemoveChoice = (choiceIndex: number) => {
    const opts = [...choices];
    opts.splice(choiceIndex, 1);
    onChange(opts);
  };

  function letter(num: number) {
    // 0 based indexing (0 = A, 1 = B, etc.)
    return String.fromCharCode(65 + num);
  }

  return (
    <div className="mt-8 ml-8">
      {choices && (
        <ul>
          {choices.map((choice, index) => (
            <li key={index} className="mb-4 group">
              <span className="text-sm pr-2 pl-2">{letter(index)}.</span>
              <input
                type="text"
                placeholder="choice"
                className="bg-slate-600 text-white w-[300px]"
                value={choice.text}
                onChange={(e) =>
                  handleChoiceChange(index, "text", e.target.value)
                }
              />
              <button
                className="ml-4 text-red-500 hover:text-red-700 hidden group-hover:inline-block"
                onClick={() => handleRemoveChoice(index)}
                tabIndex={-1}
              >
                ❌
              </button>
            </li>
          ))}
        </ul>
      )}
      <button
        // className="ml-8 underline"
        className="text-white hover:text-slate-400 text-sm font-semibold h-8 px-6 flex items-center justify-center"
        onClick={() => handleAddChoice()}
      >
        <Plus />
        Add choice
      </button>
    </div>
  );
};

export default MultipleChoiceEditor;
